import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/payroll/_layout/overview/')({
  component: () => null
});